import React from 'react';
import { IconProps } from './model/IconInterface';

const SwapIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <polyline points="17 1 21 5 17 9" /><path d="M21 5H3" /><polyline points="7 23 3 19 7 15" /><path d="M3 19h18" />
    </svg>
  );
};

export default SwapIcon;
